import { useTranslation } from 'next-i18next';
import { useMatchMedia } from 'services/media-matcher';
import { FeatureItem } from '../../feature-item/feature-item';
import { PricingTable } from './pricing-table';
function TaskViewsTable() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const isDesktop = useMatchMedia('(min-width: 960px)');
  return <PricingTable caption={t('comparison.sections.taskViews')} headerRow={<PricingTable.HeaderRow>
                    <PricingTable.HeaderCell title={t('comparison.plans.beginner.name')} description={t('comparison.plans.beginner.description')} size="xs" />
                    <PricingTable.HeaderCell title={t('comparison.plans.pro.name')} description={t('comparison.plans.pro.description')} size="xs" />
                    <PricingTable.HeaderCell title={t('comparison.plans.teams.name')} description={t('comparison.plans.teams.description')} size="xs" />
                </PricingTable.HeaderRow>} tableBody={<PricingTable.Body>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.listLayout.name')} description={t('comparison.items.listLayout.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.boardLayout.name')} description={t('comparison.items.boardLayout.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={t('comparison.items.boardLayout.pro')} />
                        <PricingTable.BodyCell data={t('comparison.items.boardLayout.team')} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.calendarLayout.name')} description={t('comparison.items.calendarLayout.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={false} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.customFilters.name')} description={t('comparison.items.customFilters.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={3} />
                        <PricingTable.BodyCell data={150} />
                        <PricingTable.BodyCell data={t('comparison.common.nForEachMember', {
        count: 150
      })} />
                    </PricingTable.BodyRow>
                </PricingTable.Body>} data-sentry-element="PricingTable" data-sentry-component="TaskViewsTable" data-sentry-source-file="task-views-table.tsx" />;
}
export { TaskViewsTable };